import { createBrowserRouter } from "react-router-dom";
import Loadable from "uicomponent/Loadable";
import { ComponentErrorBoundary } from "components/ErrorBoundary";

// routes
import AuthenticatedRoutes from "./AuthenticatedRoutes";
import UnauthenticatedRoutes from "./UnauthenticatedRoutes";
import MainLayout from "layout/MainLayout";
// Onboarding route (separate from protected routes)
const OnboardingRoute = Loadable(() => import("./OnboardingRouteWrapper"));
const Onboarding = Loadable(() => import("views/onboarding"));

// ==============================|| ROUTING RENDER ||============================== //
const router = createBrowserRouter(
  [
    AuthenticatedRoutes,
    UnauthenticatedRoutes,
    {
      path: "/onboarding",
      element: (
        <OnboardingRoute>
          {/* <Onboarding /> */}
          <MainLayout />
        </OnboardingRoute>
      ),
      children: [
        {
          path: "/onboarding",
          element: <Onboarding />,
        },
      ],
    },
  ],
  {
    basename: import.meta.env.VITE_APP_BASE_NAME,
  }
);

export default router;
